import React from 'react';
import { Instagram, ArrowRight } from 'lucide-react';
import useScrollAnimation from '@/hooks/useScrollAnimation';

const Hero = () => {
  const { ref, isVisible } = useScrollAnimation();

  const t = {
    titleLine1: 'Brands! If Your Target Audience is',
    titleLine2: 'Mothers and Housewives:',
    titleLine3Pre: 'Your Power is ',
    titleLine3Highlight: 'Persona',
    instagram: 'Instagram',
    instagramCta: 'Visit Our Page',
  };

  return (
    <section 
      ref={ref}
      id="hero" 
      className={`pt-20 pb-4 md:pb-8 flex items-center bg-black bg-opacity-70 relative overflow-hidden scroll-animate ${isVisible ? 'visible' : ''}`}
    >
      {/* Decorative elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-64 h-64 bg-[#FFDD59] rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#FFDD59] rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-8 relative z-10 w-full">
        {/* Mobile: Stack vertically and center | Desktop: Side by side */}
        <div className="flex flex-col md:grid md:grid-cols-2 gap-4 md:gap-2 items-center md:items-start mt-4 md:mt-8">
          {/* Main Title */}
          <div className="text-center md:text-left animate-slide-in-left">
            <a
              href="https://personaajans.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-[#FFDD59]/40 text-[#FFDD59]/80 text-xs uppercase tracking-wider hover:border-[#FFDD59] hover:text-[#FFDD59] transition-colors mb-4"
              data-testid="hero-powered-by-link"
            >
              Powered by Persona Ajans
              <span>→</span>
            </a>
            <h1 className="text-2xl md:text-4xl font-bold leading-tight text-white">
              {t.titleLine1}<br/>
              {t.titleLine2}<br/>
              {t.titleLine3Pre}<span className="text-[#FFDD59] persona-glow">{t.titleLine3Highlight}</span>
            </h1>
          </div>

          {/* Instagram Box - Centered on mobile */}
          <div className="flex justify-center md:justify-end w-full">
            <div className="bg-gray-900 border border-gray-700 text-white rounded-xl p-4 transition-all duration-300 card-hover-glow hover:border-[#FFDD59] text-center w-64">
              <Instagram className="mx-auto mb-2" size={32} color="#FFDD59" />
              <h3 className="text-base font-bold text-[#FFDD59] mb-2">{t.instagram}</h3>
              <a 
                href="https://www.instagram.com/personaajans" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-full mt-2 py-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white text-sm font-bold rounded-lg hover:from-purple-600 hover:to-pink-600 transition flex items-center justify-center gap-2"
              >
                {t.instagramCta}
                <ArrowRight size={16} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
